export default __webpack_public_path__ + "static/media/edit2.c61b39d4.svg";